import React from "react";
import * as CompareStyles from "./styles/CompareStyles";
import { Separator } from "../../../../common-deprecated/styles/v2/lexus/globals/Separator";
import Icon from "../../../../common-deprecated/styles/v2/lexus/globals/Icon";
import * as Text from "../../../../common-deprecated/styles/v2/lexus/utilities/Text";
import { useCompareV2Selector } from "../../redux/store";
import { CompareV2Label } from "../../utils/labels";
import { printPdf } from "../../../../common-deprecated/utils/pdfUtils";
import { getComparePDFLink } from "../../utils/utils";
import ButtonWithIcon from "../../../../common-deprecated/components/aem/lexus/button/ButtonWithIcon";
import { trackComparePdf } from "../../utils/tracking";

const PdfLink = (): JSX.Element => {
    const commonSettings = useCompareV2Selector((state) => state.commonSettings);
    const available = useCompareV2Selector((state) => state.newCarCompare.available);
    const compareContext = useCompareV2Selector((state) => state.newCarCompare.ncCompareContext);

    const sharePdf = (): void => {
        trackComparePdf();
        printPdf(getComparePDFLink(commonSettings, compareContext, available), commonSettings); // opens the PDF in new tab
    };

    return (
        <div>
            <Separator />
            <CompareStyles.PdfSection>
                {/* Button gets hidden by applying base style in base.nj template */}
                <ButtonWithIcon hasIconLeft onClick={() => sharePdf()}>
                    <Text.IconButton>
                        <CompareV2Label label="compareBodySaveAsPdf" />
                    </Text.IconButton>
                    <Icon variant="pdf" />
                </ButtonWithIcon>
            </CompareStyles.PdfSection>
        </div>
    );
};

export default PdfLink;
